import React, { useEffect } from "react";
import Calendar from "../Calendar/Calendar";
import { CalendarBanner, CalendarBannerBg, CalendarBannerContent, CalendarBannerScrollBtn } from "./BannerWithCalendarUI";
import { connect } from "react-redux";
import { AppState, AppThunkDispatch } from "../../../store";
import { getFilteredShows, getShows } from "../../../store/shows";
import { getHeroCalendarBanner } from "../../../util/ModuleHelper";
import { HeroBannerControl, HeroBannerWithCalendarControl } from "../../../typings/grid";
import { ShowFilters, thunkUpdateShows } from "../../../store/shows/action";
import { showTicketsAsync } from "../../../store/basm/action";
import { PrimaryButton } from "../UI/Button/Button";
import { Link } from "react-router-dom";

const BannerWithCalendar: React.FC<HeroBannerWithCalendarControl & BannerWithCalendarStateProps> = (props) =>
{
    const { updateShows, showTickets } = props;
    useEffect(() =>
    {
        updateShows();
    }, [updateShows]);

    const heroBannerProps: HeroBannerControl = { ...props, _contentType: "gridEditorHeroBanner" };
    const banner = getHeroCalendarBanner(heroBannerProps);

    const filter: ShowFilters =
    {
        categories: [],
        shows: [],
        startDate: new Date(),
        endDate: new Date(new Date().setDate(new Date().getFullYear() + 1)),
    };

    const myEvents = getFilteredShows(props.shows, filter);

    const handleBuyClicked = (eventNo: number, showNo?: number) =>
    {
        showTickets(eventNo, showNo);
    };

    return (
        <CalendarBanner>
            <CalendarBannerBg>
                {banner}
            </CalendarBannerBg>
            <CalendarBannerContent>
                <CalendarBannerScrollBtn />
                <PrimaryButton to="/det-sker/forestillinger/" as={Link} className="calendar-banner__btn-see-all">Se flere</PrimaryButton>
                <Calendar shows={myEvents} buyOnClick={handleBuyClicked} maxEvents={props.maxEvents} />
            </CalendarBannerContent>
        </CalendarBanner>
    );
};

const mapStateToProps = (state: AppState) => ({
    shows: getShows(state.shows)
});

const mapToDispatchProps = (dispatch: AppThunkDispatch) => ({
    updateShows: () => dispatch(thunkUpdateShows()),
    showTickets: (eventNo: number, showNo?: number) => dispatch(showTicketsAsync(eventNo, showNo))
});

type BannerWithCalendarStateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapToDispatchProps>;

export default connect(mapStateToProps, mapToDispatchProps)(BannerWithCalendar);